export default "__VITE_ASSET__2cb2df1b__"